import { Dialog } from '@chakra-ui/react'
import cn from 'clsx'
import { FC } from 'react'

import Cross from '@/assets/icons/cancel-2.svg'

import { Button } from './ui'

interface IDialogWindowProps {
	taskId?: string
	handleClick: (id?: string) => void
	open: boolean
	onClose: () => void
	titleText: string
	body?: React.ReactNode
	bodyClassname?: string
	backdropClassName?: string
	noButtonText?: React.ReactNode
	noButtonClassname?: string
	noButtonClassnameText?: string
	yesButtonText?: React.ReactNode
	yesButtonClassname?: string
	yesButtonClassnameText?: string
	hideButtons?: boolean
	closeOnEscape?: boolean
	closeOnInteractOutside?: boolean
}

const DialogWindow: FC<IDialogWindowProps> = ({
	taskId,
	handleClick,
	open,
	onClose,
	titleText,
	body,
	bodyClassname,
	backdropClassName,
	noButtonText,
	noButtonClassname,
	noButtonClassnameText,
	yesButtonText,
	yesButtonClassname,
	yesButtonClassnameText,
	hideButtons,
	closeOnEscape = true,
	closeOnInteractOutside = true
}) => {
	return (
		<Dialog.Root
			open={open}
			size='md'
			placement='center'
			closeOnEscape={closeOnEscape}
			closeOnInteractOutside={closeOnInteractOutside}
			onOpenChange={e => {
				if (!e.open) onClose()
			}}
		>
			<Dialog.Trigger />

			<Dialog.Backdrop
				className={cn('bg-black/70 backdrop-blur-xl', backdropClassName)}
			/>

			<Dialog.Positioner>
				<Dialog.Content className='rounded-[16px]'>
					<Dialog.CloseTrigger />
					<Dialog.Header className='flex justify-between'>
						<Dialog.Title className='text-[28px] font-bold'>
							{titleText}
						</Dialog.Title>
						<div className='cursor-pointer' onClick={onClose}>
							<Cross />
						</div>
					</Dialog.Header>
					<Dialog.Body className={cn('text-[16px]', bodyClassname)}>
						{body}
					</Dialog.Body>

					{!hideButtons && (
						<Dialog.Footer>
							<Button
								onClick={onClose}
								className={cn(
									'rounded-[8px] px-4 py-[14px]',
									noButtonClassname
								)}
								classNameText={cn(
									'text-black text-[16px]',
									noButtonClassnameText
								)}
							>
								{noButtonText || 'No'}
							</Button>
							<Button
								onClick={() => handleClick(taskId)}
								className={cn(
									'bg-black rounded-[8px] px-4 py-[14px]',
									yesButtonClassname
								)}
								classNameText={cn('text-[16px]', yesButtonClassnameText)}
							>
								{yesButtonText || 'Cancel'}
							</Button>
						</Dialog.Footer>
					)}
				</Dialog.Content>
			</Dialog.Positioner>
		</Dialog.Root>
	)
}

export default DialogWindow
